import {
  DOWNLOAD_SURGE_SAMPLE_FILE,
  DOWNLOAD_SURGE_SAMPLE_FILE_SUCCESS,
  DOWNLOAD_SURGE_SAMPLE_FILE_ERROR,
  DOWNLOAD_SURGE_SAMPLE_FILE_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadSurgeSampleFile = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_SURGE_SAMPLE_FILE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_SURGE_SAMPLE_FILE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_SURGE_SAMPLE_FILE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_SURGE_SAMPLE_FILE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadSurgeSampleFile;
